import React, { Component } from 'react';
import RouteComponent from '../../Route';
import superAdminConfig from '../../../../utils/routes/config/ins_super_admin_config';

/**
 * @inheritdoc
 */
class InsSuperAdminLayout extends Component {
    render() {
        return <RouteComponent routes={superAdminConfig} />;
    }
}

export default InsSuperAdminLayout;
